// extracted by mini-css-extract-plugin
module.exports = {"submit":"Q-LsN7"};